(function () {
  var g = document.querySelector('.template-product .product-single__media-group');
  if (!g) return;
  var slides = g.querySelectorAll('.product-single__media-wrapper');
  if (slides.length < 1) return;
  var bar = document.createElement('div'); bar.className = 'mz-gallery-bar';
  var fill = document.createElement('span'); bar.appendChild(fill);
  g.parentNode.insertBefore(bar, g.nextSibling);
  if (slides.length < 2) bar.style.visibility = 'hidden';
  var mq = window.matchMedia('(max-width: 749px)'), ticking = false;
  function size() {
    fill.style.width = (100 / slides.length) + '%';
    if (!mq.matches) { g.style.marginLeft = ''; return; }
    g.style.marginLeft = '0px';
    g.style.marginLeft = (-g.getBoundingClientRect().left) + 'px';
    bar.style.top = (g.offsetTop + g.offsetHeight + 12) + 'px';
  }
  window.addEventListener('resize', size, { passive: true });
  window.addEventListener('load', size);
  function update() {
    ticking = false;
    var max = g.scrollWidth - g.clientWidth;
    var p = max > 0 ? g.scrollLeft / max : 0;
    fill.style.transform = 'translateX(' + (p * (slides.length - 1) * 100) + '%)';
  }
  g.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }, { passive: true });
  var obs = new MutationObserver(function (list) {
    if (!mq.matches) return;
    list.forEach(function (m) {
      var el = m.target;
      if (el.classList.contains('product-single__media-wrapper') && !el.classList.contains('hide')) {
        var i = Array.prototype.indexOf.call(slides, el);
        g.scrollTo({ left: i * g.clientWidth, behavior: 'smooth' });
      }
    });
  });
  slides.forEach(function (s) { obs.observe(s, { attributes: true, attributeFilter: ['class'] }); });
  slides.forEach(function (s) { var i = s.querySelector('img.lazyload'); if (i && window.lazySizes) lazySizes.loader.unveil(i); });
  size(); update();
})();
